<template>
  <div class="severity">
    <h3 class="severity-title">Overall Severity of Sample</h3>
    <div class="severity-labels">
      <div class="severity-label">
        <div class="severity-label-color severity-label-normal">
          <span class="severity-label-number">0</span>
        </div>
        <span class="severity-label-title">Normal</span>
      </div>
      <div class="severity-label">
        <div class="severity-label-color severity-label-reportable">
          <span class="severity-label-number">1</span>
        </div>
        <span class="severity-label-title">Reportable</span>
      </div>
      <div class="severity-label">
        <div class="severity-label-color severity-label-abnormal">
          <span class="severity-label-number">2</span>
        </div>
        <span class="severity-label-title">Abnormal</span>
      </div>
      <div class="severity-label">
        <div class="severity-label-color severity-label-critical">
          <span class="severity-label-number">3</span>
        </div>
        <span class="severity-label-title">Critical</span>
      </div>
      <div :class="`severity-indicator severity-indicator-${severityCode.toLowerCase()}`">
        <div class="severity-indicator-inner"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CoolantSampleReportSeverity',
  props: {
    severityCode: {
      type: String,
      required: true
    }
  }
};
</script>
